<ion-header>
  <ion-toolbar color="tertiary">
    <ion-title>PO Report</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="po-report-placeholder">
    <ion-icon name="document-text-outline"></ion-icon>
    <h2>PO report viewer coming soon</h2>
    <p class="po-report-po">PO {{ poNumber }}</p>
    <p class="po-report-note">
      The embedded PO report is being built and will appear here.
    </p>
  </div>
</ion-content>
